import { createRootRoute, HeadContent, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  // Default document title; child routes override it via their own `head`.
  // <HeadContent> below applies the deepest match's title to the browser tab.
  head: () => ({ meta: [{ title: "Hearth" }] }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
});
